import styled from "styled-components";

import {
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	MOBILE_L_BP,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_WHITE,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	height: 284px;
	width: 235px;
	margin: 11px 6px 6px 11px;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 20px;
	background: ${COLOR_WHITE};
	box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.1);
	border-radius: 3px;
	position: relative;
	cursor: pointer;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		max-height: 225px;
		width: 163px;
		margin: 11px 2px 2px 11px;
	}
`;
export const Title = styled.span`
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 18px;
	line-height: 27px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	margin-top: 10px;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		margin-top: 5px;
	}
`;

export const Company = styled.span`
	font-weight: ${FONT_WT_LIGHT};
	font-size: 16px;
	line-height: 20px;
	font-style: italic;
	text-align: center;
	margin-top: 25px;
	color: ${COLOR_TEXT_PRIMARY_B2C};

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		margin-top: 5px;
	}
`;

export const Designation = styled.span`
	font-weight: ${FONT_WT_LIGHT};
	font-size: 16px;
	line-height: 20px;
	text-align: center;
	margin-top: 5px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
`;
export const ImageContainer = styled.div`
	.alumni-image {
		margin: auto;
		height: 130px;
		border-radius: 50%;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.alumni-image {
			margin-top: auto;
			height: 87px;
			border-radius: 50%;
		}
	}
`;

export const TypeImageContainer = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	height: 26px;
	width: 38px;
	background-color: ${(props) => (props.video ? "#FF7155" : "#A9DEFF")};

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		height: 17px;
		width: 26px;
	}
`;

export const Icon = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 2px;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		picture {
			img {
				height: 12px;
				width: 12px;
			}
		}
		margin-top: 0;
	}
`;
